import axios from 'axios';
import { ENV_CONFIG } from '../config/environment';
import { clearAllCompanyStorage } from '../utils/companyStorage';

// Crear instancia de axios configurada
const api = axios.create({
  baseURL: ENV_CONFIG.API_BASE_URL,
  timeout: ENV_CONFIG.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas y errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    if (error.response?.status === 401) {
      // Token expirado o inválido
      console.log('Token inválido, redirigiendo a login...');
      localStorage.removeItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      localStorage.removeItem(ENV_CONFIG.USER_KEY);
      clearAllCompanyStorage();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

class EmpleadoConceptoService {
  // Obtener empleados con sus conceptos por empresa (COMPLETO - incluye PLAMEs)
  async obtenerEmpleadosConConceptosPorEmpresa(empresaId) {
    try {
      console.log('🔍 Obteniendo empleados CON CONCEPTOS por empresa ID:', empresaId);
      console.log('🌐 URL del endpoint:', `/empleados-conceptos/empresa/${empresaId}`);
      console.log('📤 Método:', 'GET');
      
      const response = await api.get(`/empleados-conceptos/empresa/${empresaId}`);
      
      console.log('✅ Respuesta recibida del servidor');
      console.log('📥 Status:', response.status);
      console.log('📥 Respuesta completa:', response);
      console.log('📥 Data completa:', response.data);
      
      if (response.data.success && response.data.data) {
        const empleados = response.data.data;
        const meta = response.data.meta;
        
        console.log('📊 Metadatos:', meta);
        console.log('👥 Total empleados con conceptos:', empleados.length);
        
        // Mostrar estadísticas de conceptos
        let totalConceptos = 0;
        let totalConceptosPlame = 0;
        
        empleados.forEach((empleado, index) => {
          totalConceptos += empleado.total_conceptos || 0;
          totalConceptosPlame += empleado.conceptos_plame || 0;
          
          if (index < 3) { // Mostrar solo los primeros 3 como ejemplo
            console.log(`\n👤 Empleado ${index + 1} CON CONCEPTOS:`);
            console.log('  - ID:', empleado.id);
            console.log('  - Nombre:', empleado.nombre_completo);
            console.log('  - Documento:', empleado.numero_documento);
            console.log('  - Cargo:', empleado.cargo);
            console.log('  - Empresa ID:', empleado.empresa_id);
            console.log('  - Total Conceptos:', empleado.total_conceptos);
            console.log('  - Conceptos Activos:', empleado.conceptos_activos);
            console.log('  - Conceptos PLAME:', empleado.conceptos_plame);
            
            // Mostrar algunos conceptos como ejemplo
            if (empleado.conceptos && empleado.conceptos.length > 0) {
              console.log('  - Conceptos (primeros 3):');
              empleado.conceptos.slice(0, 3).forEach((concepto, cIndex) => {
                console.log(`    ${cIndex + 1}. ${concepto.atributo?.nombre || 'Sin nombre'} (${concepto.atributo?.codigo_plame || 'Sin PLAME'}): ${concepto.valor}`);
              });
            }
          }
        });
        
        console.log(`\n📊 RESUMEN EMPLEADOS CON CONCEPTOS:`);
        console.log(`  - Total empleados: ${empleados.length}`);
        console.log(`  - Total conceptos: ${totalConceptos}`);
        console.log(`  - Total conceptos PLAME: ${totalConceptosPlame}`);
        
        return {
          success: true,
          data: empleados,
          meta: meta,
          estadisticas: {
            total_empleados: empleados.length,
            total_conceptos: totalConceptos,
            total_conceptos_plame: totalConceptosPlame
          }
        };
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo empleados con conceptos por empresa:');
      console.error('🔴 Status:', error.response?.status);
      console.error('🔴 Data:', error.response?.data);
      console.error('🔴 Message:', error.message);
      console.error('🔴 Empresa ID:', empresaId);
      throw new Error(error.response?.data?.message || 'Error al obtener empleados con conceptos');
    }
  }

  // Obtener empleados CON conceptos por empresa (SERVICIO ACTUALIZADO - incluye conceptos)
  async obtenerEmpleadosBasicosPorEmpresa(empresaId) {
    try {
      console.log('🔍 Obteniendo empleados CON CONCEPTOS por empresa ID:', empresaId);
      console.log('🌐 URL del endpoint:', `/empleados-conceptos/basicos/empresa/${empresaId}`);
      console.log('📤 Método:', 'GET');
      
      const response = await api.get(`/empleados-conceptos/basicos/empresa/${empresaId}`);
      
      console.log('✅ Respuesta recibida del servidor');
      console.log('📥 Status:', response.status);
      console.log('📥 Respuesta completa:', response);
      console.log('📥 Data completa:', response.data);
      
      if (response.data.success && response.data.data) {
        const empleados = response.data.data;
        const meta = response.data.meta;
        
        console.log('📊 Metadatos:', meta);
        console.log('👥 Total empleados con conceptos:', empleados.length);
        
        // Mostrar estadísticas de conceptos
        let totalConceptosServicio2 = 0;
        let totalConceptosPlameServicio2 = 0;
        
        empleados.forEach((empleado, index) => {
          totalConceptosServicio2 += empleado.total_conceptos || 0;
          totalConceptosPlameServicio2 += empleado.conceptos_plame || 0;
          
          if (index < 3) { // Mostrar solo los primeros 3 como ejemplo
            console.log(`\n👤 Empleado CON CONCEPTOS ${index + 1}:`);
            console.log('  - ID:', empleado.id);
            console.log('  - Nombre:', empleado.nombre_completo);
            console.log('  - Documento:', empleado.numero_documento);
            console.log('  - Cargo:', empleado.cargo);
            console.log('  - Estado:', empleado.estado);
            console.log('  - Empresa ID:', empleado.empresa_id);
            console.log('  - Total Conceptos:', empleado.total_conceptos);
            console.log('  - Conceptos Activos:', empleado.conceptos_activos);
            console.log('  - Conceptos PLAME:', empleado.conceptos_plame);
            console.log('  - AFP:', empleado.afp?.nombre || 'Sin AFP');
            console.log('  - Empresa:', empleado.empresa?.nombre || 'Sin empresa');
            
            // Mostrar algunos conceptos como ejemplo
            if (empleado.conceptos && empleado.conceptos.length > 0) {
              console.log('  - Conceptos (primeros 3):');
              empleado.conceptos.slice(0, 3).forEach((concepto, cIndex) => {
                console.log(`    ${cIndex + 1}. ${concepto.atributo?.nombre || 'Sin nombre'} (PLAME: ${concepto.atributo?.codigo_plame || 'N/A'}): ${concepto.valor}`);
              });
            }
          }
        });
        
        console.log(`\n📊 RESUMEN SERVICIO ACTUALIZADO:`);
        console.log(`  - Total empleados: ${empleados.length}`);
        console.log(`  - Total conceptos: ${totalConceptosServicio2}`);
        console.log(`  - Total conceptos PLAME: ${totalConceptosPlameServicio2}`);
        
        return {
          success: true,
          data: empleados,
          meta: meta,
          estadisticas: {
            total_empleados: empleados.length,
            total_conceptos: totalConceptosServicio2,
            total_conceptos_plame: totalConceptosPlameServicio2
          }
        };
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo empleados con conceptos por empresa:');
      console.error('🔴 Status:', error.response?.status);
      console.error('🔴 Data:', error.response?.data);
      console.error('🔴 Message:', error.message);
      console.error('🔴 Empresa ID:', empresaId);
      throw new Error(error.response?.data?.message || 'Error al obtener empleados con conceptos');
    }
  }

  // Obtener estadísticas de empleados y conceptos por empresa
  async obtenerEstadisticasEmpresa(empresaId) {
    try {
      console.log('🔍 Obteniendo estadísticas de empresa ID:', empresaId);
      console.log('🌐 URL del endpoint:', `/empleados-conceptos/estadisticas/empresa/${empresaId}`);
      console.log('📤 Método:', 'GET');
      
      const response = await api.get(`/empleados-conceptos/estadisticas/empresa/${empresaId}`);
      
      console.log('✅ Estadísticas obtenidas del servidor');
      console.log('📥 Status:', response.status);
      console.log('📥 Data completa:', response.data);
      
      if (response.data.success && response.data.data) {
        const stats = response.data.data;
        
        console.log('📊 ESTADÍSTICAS DE LA EMPRESA:');
        console.log('  - Empresa ID:', stats.empresa_id);
        console.log('  - Total Empleados:', stats.total_empleados);
        console.log('  - Empleados Activos:', stats.empleados_activos);
        console.log('  - Empleados Inactivos:', stats.empleados_inactivos);
        console.log('  - Total Conceptos:', stats.total_conceptos);
        console.log('  - Conceptos Activos:', stats.conceptos_activos);
        console.log('  - Conceptos Inactivos:', stats.conceptos_inactivos);
        console.log('  - Promedio Conceptos por Empleado:', stats.promedio_conceptos_por_empleado);
        
        return {
          success: true,
          data: stats
        };
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error obteniendo estadísticas de empresa:');
      console.error('🔴 Status:', error.response?.status);
      console.error('🔴 Data:', error.response?.data);
      console.error('🔴 Message:', error.message);
      console.error('🔴 Empresa ID:', empresaId);
      throw new Error(error.response?.data?.message || 'Error al obtener estadísticas');
    }
  }

  // Validar conexión con la API
  async checkApiConnection() {
    try {
      // Usar endpoint de estadísticas con empresa ID = 1 como test
      const response = await api.get('/empleados-conceptos/estadisticas/empresa/1');
      return response.status === 200;
    } catch (error) {
      console.error('❌ Error verificando conexión API empleados-conceptos:', error);
      return false;
    }
  }
}

export default new EmpleadoConceptoService(); 